import { UpdatePwdForm } from '../../../components/UpdatePwdForm/UpdatePwdForm';

const UpdatePwd = () => <UpdatePwdForm />;

export default UpdatePwd;
